import _export from '../internals/export.js';
import iterate$1 from '../internals/iterate.js';
import createProperty$1 from '../internals/create-property.js';

var $ = _export;
var iterate = iterate$1;
var createProperty = createProperty$1; // `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries

$({
  target: 'Object',
  stat: true
}, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, {
      AS_ENTRIES: true
    });
    return obj;
  }
});
